import axios from 'axios';
import config from '../../../../helpers/config';

export default function verifyAddress(address) {
  const url = config.mandiBaseUrl + config.addressValidationApi;
  const {
    line1, line2, city, state, zipCode,
  } = address;
  const payload = {
    Line1: line1,
    Line2: line2,
    City: city,
    State: state,
    ZipCode: zipCode,
  };

  return axios.post(url, payload, {
    withCredentials: true,
  });
}
